let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fNCmt")).then(() => parcelRequire('5K8q7'));